import {
  mobile_number,
  store_details,
  store_filter,
  category_products,
  cart_order_details,
  cart_quantity,
  login_prescribe_data,
  clear_login_prescribe_data,
} from "./ActionType";

export const setMobileNumber = (number) => {
  return {
    type: mobile_number,
    payload: number,
  };
};

export const setStoreDetails = (data) => {
  return {
    type: store_details,
    payload: data,
  };
};

export const setStoreFilter = (data) => {
  return {
    type: store_filter,
    payload: data,
  };
};
export const setCategoryProducts = (data) => {
  return {
    type: category_products,
    payload: data,
  };
};

export const setCartOrderDetails = (data) => {
  return {
    type: cart_order_details,
    payload: data,
  };
};

export const setCartQuantity = (count) => {
  return {
    type: cart_quantity,
    payload: count,
  };
};

export const setPrescribeData = (data) => {
  return {
    type: login_prescribe_data,
    payload: data,
  };
};

export const clearLoginPrescribeData = () => ({
  type: clear_login_prescribe_data,
});
